import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { OrderRecordSearchQueryResponse, OrderRecordCreateResponse, OrderRecordCreateRequest, OrderRecordDetailsResponse, OrderRecordDashboardResponse } from 'app/models/order-records.model';


/**
 * Service for fetching order data from the backend API.
 */
@Injectable({
  providedIn: 'root',
})
export class OrderService {
  /**
   * Constructs the orderService with HttpClient injection.
   * 
   * @param http Angular HttpClient for making HTTP requests
   */
  constructor(private http: HttpClient) { }

  /**
   * Fetches a paginated list of orders from the API.
   * 
   * @param page The page number to fetch (default: 1)
   * @param limit The number of items per page (default: 10)
   * @returns Observable emitting the API response containing order profiles
   */
  getOrderList(page: number = 1, limit: number = 10): Observable<OrderRecordSearchQueryResponse> {
    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });
    const fetchApi: string = `${environment.api_url}//order-records`;
    const params: HttpParams = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    return this.http.get<OrderRecordSearchQueryResponse>(fetchApi, { params, headers });
  }

  /**
   * Fetches a paginated list of customers from the API.
   * 
   * @param order_create new order create base on input data   
   * @returns Observable emitting the API response containing customer profiles
   */
  orderCreate(order_create: OrderRecordCreateRequest): Observable<OrderRecordCreateResponse> {
    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });

    const fetchApi: string = `${environment.api_url}/order-records/create`;
    return this.http.post<OrderRecordCreateResponse>(fetchApi, order_create, { headers });

  }

  /**
   * Fetches a paginated list of customers from the API.
   * 
   * @param order_record_id  The unique identifier of the order record whose details need to be fetched. 
   * @returns Observable emitting the API response containing customer profiles
   */
  getOrderDetails(order_record_id: string): Observable<OrderRecordDetailsResponse> {

    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });

    const fetchApi: string = `${environment.api_url}/order-records/details`;
    const params: HttpParams = new HttpParams()
      .set('order_record_id', order_record_id)
    return this.http.get<OrderRecordDetailsResponse>(fetchApi, { params, headers });

  }

  /**
   * Fetches a paginated list of customers from the API.
   * 
   * @returns Observable emitting the API response containing customer profiles
   */
  getOrderRecords(): Observable<OrderRecordDashboardResponse> {
    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });

    const fetchApi: string = `${environment.api_url}/order-records/dashboard`;

    return this.http.get<OrderRecordDashboardResponse>(fetchApi, { headers });

  }
}